export const LEGACY_HOST = "emr-web-pro.web.app";
export const CANONICAL_ORIGIN = "https://emariner.app";

type RedirectableLocation = {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
  replace: (url: string) => void;
};

export function redirectIfLegacyHost(loc: RedirectableLocation): boolean {
  if (loc.hostname !== LEGACY_HOST) {
    return false;
  }
  loc.replace(`${CANONICAL_ORIGIN}${loc.pathname}${loc.search}${loc.hash}`);
  return true;
}
